import React, { useMemo } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { ui } from "../../shared/styles/uiSystem"

const CONFIG_MODULES = [
  {
    key: "home",
    label: "Centro",
    path: "/settings",
    match: (pathname) => pathname === "/settings",
  },
  {
    key: "clinic-resources",
    label: "Sedes y recursos",
    path: "/settings/clinic-resources",
    match: (pathname) => pathname.startsWith("/settings/clinic-resources"),
  },
  {
    key: "team-access",
    label: "Equipo y accesos",
    path: "/settings/team-access",
    match: (pathname) => pathname.startsWith("/settings/team-access"),
  },
  {
    key: "schedule-availability",
    label: "Agenda y disponibilidad",
    path: "/settings/schedule-availability",
    match: (pathname) => pathname.startsWith("/settings/schedule-availability"),
  },
  {
    key: "treatments-permissions",
    label: "Tratamientos y permisos",
    path: "/settings/treatments-permissions",
    match: (pathname) => pathname.startsWith("/settings/treatments-permissions"),
  },
  {
    key: "clinical-engine",
    label: "Motor clínico",
    path: "/settings/clinical-engine",
    match: (pathname) => pathname.startsWith("/settings/clinical-engine"),
  },
  {
    key: "system-account",
    label: "Sistema y cuenta",
    path: "/settings/system-account",
    match: (pathname) => pathname.startsWith("/settings/system-account"),
  },
]

export default function SettingsModuleScaffold({
  eyebrow = "Configuración",
  title,
  subtitle,
  tabs = [],
  activeTab,
  onTabChange,
  actions = null,
  children,
}) {
  const location = useLocation()
  const navigate = useNavigate()

  const currentModule = useMemo(() => {
    return CONFIG_MODULES.find((module) => module.match(location.pathname)) || null
  }, [location.pathname])

  return (
    <div style={ui.page}>
      <div
        style={{
          borderRadius: 24,
          padding: 20,
          background: "linear-gradient(135deg, #0f172a 0%, #1e293b 56%, #2563eb 100%)",
          color: "#ffffff",
          marginBottom: 14,
          boxShadow: "0 20px 44px rgba(15,23,42,0.18)",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0,1fr)",
            gap: 12,
          }}
        >
          <div>
            <div
              style={{
                display: "inline-flex",
                padding: "6px 10px",
                borderRadius: 999,
                background: "rgba(255,255,255,0.10)",
                border: "1px solid rgba(255,255,255,0.14)",
                fontSize: 11,
                fontWeight: 800,
                marginBottom: 10,
                letterSpacing: 0.35,
              }}
            >
              {eyebrow.toUpperCase()}
            </div>

            <div
              style={{
                fontSize: 28,
                fontWeight: 900,
                lineHeight: 1.05,
                letterSpacing: "-0.03em",
              }}
            >
              {title}
            </div>

            <div
              style={{
                fontSize: 13,
                color: "rgba(255,255,255,0.82)",
                marginTop: 7,
                lineHeight: 1.45,
                maxWidth: 880,
              }}
            >
              {subtitle}
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          border: "1px solid #e2e8f0",
          borderRadius: 18,
          background: "#ffffff",
          boxShadow: "0 8px 22px rgba(15,23,42,0.04)",
          padding: 14,
          marginBottom: 14,
          display: "grid",
          gap: 12,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div>
            <div
              style={{
                fontSize: 11,
                color: "#64748b",
                textTransform: "uppercase",
                letterSpacing: 0.35,
                fontWeight: 900,
              }}
            >
              Navegación de configuración
            </div>

            <div
              style={{
                marginTop: 4,
                fontSize: 14,
                fontWeight: 900,
                color: "#0f172a",
              }}
            >
              {currentModule?.label || "Configuración"}
            </div>
          </div>

          <button
            onClick={() => navigate("/settings")}
            style={{
              minHeight: 36,
              padding: "8px 12px",
              borderRadius: 12,
              border: "1px solid #cbd5e1",
              background: "#ffffff",
              color: "#0f172a",
              cursor: "pointer",
              fontWeight: 800,
              fontSize: 12,
            }}
          >
            Volver al centro
          </button>
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          {CONFIG_MODULES.filter((module) => module.key !== "home").map((module) => {
            const isActive = currentModule?.key === module.key

            return (
              <button
                key={module.key}
                onClick={() => navigate(module.path)}
                style={{
                  minHeight: 36,
                  padding: "8px 12px",
                  borderRadius: 999,
                  border: isActive ? "1px solid #1d4ed8" : "1px solid #cbd5e1",
                  background: isActive ? "#eff6ff" : "#ffffff",
                  color: isActive ? "#1d4ed8" : "#334155",
                  cursor: "pointer",
                  fontWeight: 900,
                  fontSize: 12,
                }}
              >
                {module.label}
              </button>
            )
          })}
        </div>
      </div>

      {(tabs.length || actions) && (
        <div
          style={{
            border: "1px solid #e2e8f0",
            borderRadius: 18,
            background: "#ffffff",
            boxShadow: "0 8px 22px rgba(15,23,42,0.04)",
            padding: 14,
            marginBottom: 14,
            display: "grid",
            gap: 12,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 12,
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {tabs.length ? (
              <div
                style={{
                  display: "flex",
                  gap: 8,
                  flexWrap: "wrap",
                }}
              >
                {tabs.map((tab) => {
                  const isActive = activeTab === tab.key

                  return (
                    <button
                      key={tab.key}
                      onClick={() => onTabChange(tab.key)}
                      style={{
                        minHeight: 36,
                        padding: "8px 12px",
                        borderRadius: 999,
                        border: isActive ? "1px solid #1d4ed8" : "1px solid #cbd5e1",
                        background: isActive ? "#1d4ed8" : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        cursor: "pointer",
                        fontWeight: 900,
                        fontSize: 12,
                      }}
                    >
                      {tab.label}
                    </button>
                  )
                })}
              </div>
            ) : (
              <div />
            )}

            {actions ? <div>{actions}</div> : null}
          </div>
        </div>
      )}

      <div style={{ display: "grid", gap: 14 }}>{children}</div>
    </div>
  )
}

export function SettingsLegacyHost({
  label = "Módulo heredado",
  title,
  subtitle,
  children,
}) {
  return (
    <div
      style={{
        borderRadius: 20,
        border: "1px solid #e2e8f0",
        background: "#ffffff",
        boxShadow: "0 8px 22px rgba(15,23,42,0.04)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: 14,
          borderBottom: "1px solid #e2e8f0",
          background: "#f8fafc",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            padding: "4px 8px",
            borderRadius: 999,
            background: "#eff6ff",
            border: "1px solid #bfdbfe",
            color: "#1d4ed8",
            fontSize: 11,
            fontWeight: 800,
            marginBottom: 8,
          }}
        >
          {label}
        </div>

        {title ? (
          <div
            style={{
              fontSize: 16,
              fontWeight: 900,
              color: "#0f172a",
              lineHeight: 1.2,
            }}
          >
            {title}
          </div>
        ) : null}

        {subtitle ? (
          <div
            style={{
              fontSize: 12.5,
              color: "#64748b",
              marginTop: 4,
              lineHeight: 1.4,
              maxWidth: 900,
            }}
          >
            {subtitle}
          </div>
        ) : null}
      </div>

      <div style={{ background: "#ffffff" }}>{children}</div>
    </div>
  )
}